import {FETCH_COACH} from '/enum/request.enum';
import {request} from '/redux/api/request';
import {createPromisedAction, handleCoachCompetency} from '/util/action.util';

import {getErrorHandler} from './apiError.action';

export const GET_INFO: string = 'CURRENT_USER/GET_INFO';
export const SET_EARNINGS: string = 'CURRENT_USER/SET_EARNINGS';

export const getInfo = createPromisedAction(
  GET_INFO,
  [],
  (
    dispatchMe: any,
    inputPayload: {trackLoginEvent?: boolean} = {},
    dispatch: any,
  ) => {
    const {trackLoginEvent = false} = inputPayload;
    return request(FETCH_COACH)
      .then(coach =>
        handleCoachCompetency(coach, {
          trackLoginEvent,
        }),
      )
      .then(({coach, competency}) => {
        return dispatchMe(() => ({coach, competency}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          shouldRetry: false,
          shouldSignOut: false,
        }),
      );
  },
);

export const setEarnings = createPromisedAction(SET_EARNINGS, [
  'coachId',
  'commissionLastWeek',
  'bonusesLastMonth',
  'incomeLastMonth',
]);
